import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PasswordStrengthBarComponent } from '@app/components/password-strength-bar.component';
import { LoadingButtonComponent } from '@app/components/buttom/loading-button.component';
import { ToastService } from '@core/services/toast.service';
import { AuthService } from '@core/services/auth.service';
import { finalize } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormError, FormValidationHelper } from '@/app/shared/validators/form-validation.helper';

@Component({
  selector: 'app-new-pw',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    PasswordStrengthBarComponent,
    LoadingButtonComponent,
    TranslateModule
  ],
  templateUrl: './new-pw.component.html',
})
export class NewPwComponent {
  form: FormGroup;
  isLoading = false;

  constructor(
    private fb: FormBuilder,
    private toast: ToastService,
    public activeModal: NgbActiveModal,
    private authService: AuthService,
    public router: Router,
    public validationHelper: FormValidationHelper

  ) {
    this.form = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(8)]],
        newPassword: ['', [Validators.required, Validators.minLength(8)]],
        confirmPassword: ['', Validators.required],
      },
      {
        validators: [
          this.passwordMatchValidator,
          this.newPasswordNotSameAsOldValidator,
        ],
      }
    );
  }

  /** Getter để bind cho strength bar */
  get newPassword(): string {
    return this.form.get('newPassword')?.value || '';
  }

  /** Confirm password phải khớp với newPassword */
  private passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    const newPassword = control.get('newPassword')?.value;
    const confirmPassword = control.get('confirmPassword')?.value;
    return newPassword && confirmPassword && newPassword !== confirmPassword
      ? { passwordMismatch: true }
      : null;
  }

  /** New password không được trùng với old password */
  private newPasswordNotSameAsOldValidator(control: AbstractControl): ValidationErrors | null {
    const oldPass = control.get('password')?.value;
    const newPass = control.get('newPassword')?.value;
    return oldPass && newPass && oldPass === newPass
      ? { sameAsOldPassword: true }
      : null;
  }

  /** Check lỗi control hoặc lỗi form-level */
  hasError(controlName: string, error: string): boolean {
    const ctrl = this.form.get(controlName);
    if (!ctrl) return false;

    // Check lỗi control-level
    if (ctrl.touched && ctrl.hasError(error)) {
      return true;
    }

    // Check lỗi form-level
    if (ctrl.touched && this.form.hasError(error)) {
      if (
        (error === 'sameAsOldPassword' && controlName === 'newPassword') ||
        (error === 'passwordMismatch' && controlName === 'confirmPassword')
      ) {
        return true;
      }
    }

    return false;
  }

  /** Submit đổi mật khẩu */
  updatePassword() {
    this.validationHelper.clearFormErrors();
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isLoading = true;

    const { password, newPassword } = this.form.value;

    this.authService.changePassword(password, newPassword).pipe(finalize(() => (this.isLoading = false)))
      .subscribe(result => {
        if (result.success) {
          this.activeModal.close(true);
          this.toast.success(result.message, { delay: 1000 });
          setTimeout(() => {
            this.router.navigate(['/auth/sign-in']);
          }, 2000);

        } else {
          this.validationHelper.setFormErrors(result.message as unknown as FormError[]);
        }
      });

    // this.authService
    //   .newPassword(password, newPassword)
    //   .pipe(finalize(() => (this.isLoading = false)))
    //   .subscribe({
    //     next: (res) => {

    //       if (res) {


    //         this.router.navigate(['/auth/sign-in']);
    //       } else {
    //         this.toast.error('Không thể đổi mật khẩu. Vui lòng thử lại!', { delay: 4000 });
    //       }
    //     },
    //     error: (err) => {
    //       console.error(err);
    //       this.toast.error('Có lỗi xảy ra khi đổi mật khẩu!', { delay: 4000 });
    //        this.activeModal.close(true);
    //     },
    //   });
  }

  isFieldInvalid(fieldName: string): boolean {
    return this.validationHelper.isFieldInvalid(fieldName);
  }

  getFieldError(fieldName: string): string {
    return this.validationHelper.getFieldError(fieldName);
  }
}
